export const itemColors = {
  PLATFORMS: '#2e7d32',
  LANGUAGES_FRAMEWORKS: '#1976d2',
  TOOLS: '#ed6c02',
  TECHNIQUES: '#9c27b0'
};
